import { ChatIcon } from "assets";
import React from "react";

export function WhatsappButton() {
  return (
    <div className="group fixed right-10 bottom-5 z-50">
      <div className="flex items-center bg-success text-white rounded-xl overflow-hidden transition-all duration-300 w-[60px] group-hover:w-[200px] hover:bg-gradient-to-r from-success to-emerald-600 shadow-lg">
        <div className="w-[60px] h-[60px] flex items-center justify-center shrink-0">
          <ChatIcon alt="Chat on Whatsapp" className="w-10 h-10" />
        </div>

        <div className="flex flex-col justify-center h-[60px] px-3 opacity-0 group-hover:opacity-100 transition-all duration-300">
          <a
            href="https://api.whatsapp.com/send?phone=923007886861&text=Hi%20I%20am%20interested%20in%20your%20services.%20Can%20you%20please%20share%20more%20details?"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm leading-tight whitespace-nowrap hover:text-green-200 transition"
          >
            +923007886861
          </a>

          {/* <div className="border-t border-green-400 my-1"></div>

          <a
            href="https://api.whatsapp.com/send?phone=923007886862&text=Hi%20I%20am%20interested%20in%20your%20services.%20Can%20you%20please%20share%20more%20details?"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm leading-tight whitespace-nowrap hover:text-green-200 transition"
          >
            +923007886862
          </a> */}
        </div>
      </div>
    </div>
  );
}
